import Exact from './rules/exact';
import Range from './rules/range';

export default class AdvancedFilters {
  constructor() {
    this.$fields = [];
    this.$filters = [];
    this.$items = [];

    this.addField({
      name: 'EXACT',
      instance: new Exact(
        {
          items: this.$items,
          filters: this.$filters,
        },
      ),
    });
    this.addField({
      name: 'RANGE',
      instance: new Range(
        {
          items: this.$items,
          filters: this.$filters,
        },
      ),
    });
  }

  addFilter(filter) {
    this.$filters.push(filter);

    return this;
  }

  resetFilters() {
    this.$filters = [];
    this.$fields
      .map((field) => field.instance)
      .forEach((field) => field.resetIsValid());

    return this;
  }

  addItem(item) {
    this.$items.push(item);

    return this;
  }

  resetItems() {
    this.$items = [];

    return this;
  }

  addField(field) {
    this.$fields.push(field);

    return this;
  }

  getFields() {
    return this.$fields.filter((field) => field.instance.isEnabled());
  }

  validate() {
    this.$fields
      .forEach((field) => {
        this.$filters.forEach((filter) => {
          if (filter.type === field.name) {
            field.instance.validate(this.$items[0], filter.value);
          }
        });
      });

    return this;
  }

  isValid() {
    return this.$fields
      .filter((field) => field.instance.isValid())
      .length === 0;
  }
}
